import { render } from "./ForecastStates.vue?vue&type=template&id=5878ef22"
import script from "./ForecastStates.vue?vue&type=script&lang=js"
export * from "./ForecastStates.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__